<template>
  <div class="col-6 d-flex justify-content-end pl-8">
    <BaseSelect
      :select-label="$label('page.shop.sorting.sort')"
      :selected-value="selectedValue"
      :options="sortingOptions"
      select="sort"
      :on-change="onSortChange"
    />
  </div>
</template>

<script>
import BaseSelect from '~/components/BaseSelect'

export default {
  components: {
    BaseSelect,
  },
  props: {
    selectedValue: {
      type: String,
      required: true,
    },
    onSortChange: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      sortingOptions: [
        {
          id: 'displayOrder',
          label: this.$label('page.shop.sorting.displayOrder'),
        },
        {
          id: 'author-asc',
          label: this.$label('page.shop.sorting.authAsc'),
        },
        {
          id: 'author-desc',
          label: this.$label('page.shop.sorting.authDesc'),
        },
        {
          id: 'price-asc',
          label: this.$label('page.shop.sorting.priceAsc'),
        },
        {
          id: 'price-desc',
          label: this.$label('page.shop.sorting.priceDesc'),
        },
        {
          id: 'rating-desc',
          label: this.$label('page.shop.sorting.rating'),
        },
      ],
    }
  },
}
</script>
